// extracted by mini-css-extract-plugin
export default {"FeatureTogglesDashboard":"featureTogglesDashboard_FeatureTogglesDashboard_dwMYg"};